<template>
	<div class="main-wrapper">
		<layout-header></layout-header>
		<layout-sidebar></layout-sidebar>

		<!-- Page Wrapper -->
		<div class="page-wrapper">
			<div class="content container-fluid">
				<indexpage></indexpage>
			</div>
		</div>
		<!-- /Page Wrapper -->
	</div>
</template>
